module.exports = __webpack_public_path__ + "img/live.5a96220f.png";